import { CheckIcon } from '@phosphor-icons/react'
import { ScoopText } from '../ScoopText/ScoopText'
import styles from './ScoopStepper.module.scss'

/**
 * ScoopStepper - A horizontal stepper component for multi-step workflows
 *
 * @component
 * @param {Object} props - Component props
 * @param {Array<string>} props.steps - Array of step labels
 * @param {number} props.activeStep - Index of the currently active step (0-based)
 * @param {string} [props.className] - Additional CSS classes to apply
 *
 * @example
 * <ScoopStepper
 *   steps={['Connection', 'Fact Table', 'Dimensions', 'Test & Save']}
 *   activeStep={1}
 * />
 */
export const ScoopStepper = ({ steps, activeStep, className = '' }) => {
    return (
        <div className={`${styles.stepper} ${className}`}>
            {steps.map((label, index) => {
                const isCompleted = index < activeStep
                const isActive = index === activeStep
                const isLast = index === steps.length - 1

                return (
                    <div
                        key={label}
                        className={`${styles.stepWrapper} ${isLast ? styles.lastStep : ''}`}
                    >
                        <div className={styles.stepContainer}>
                            {/* Step Circle */}
                            <div
                                className={`${styles.stepCircle} ${
                                    isCompleted
                                        ? styles.completed
                                        : isActive
                                          ? styles.active
                                          : styles.inactive
                                }`}
                            >
                                {isCompleted ? (
                                    <CheckIcon size={16} weight="bold" />
                                ) : (
                                    <ScoopText className={styles.stepNumber}>{index + 1}</ScoopText>
                                )}
                            </div>

                            {/* Step Label */}
                            <ScoopText
                                className={`${styles.stepLabel} ${
                                    isActive ? styles.activeLabel : styles.inactiveLabel
                                }`}
                            >
                                {label}
                            </ScoopText>
                        </div>

                        {/* Connector Line */}
                        {!isLast && (
                            <div
                                className={`${styles.connector} ${
                                    isCompleted
                                        ? styles.completedConnector
                                        : styles.incompleteConnector
                                }`}
                            />
                        )}
                    </div>
                )
            })}
        </div>
    )
}
